<app-table-generator
    [tableInput]="tableInput"
    [widgetRef]="widgetRef"
    (gridRef)="agGrid = $event"
    (selectionChanged)="onSelectionChanged($event)"
    [showPagination]="true"
></app-table-generator>
